import type { NoteSource } from "./constants";

/** How each note source is labelled in lists; a source this version doesn't know yet shows its name. */
export function sourceLabel(source: NoteSource | string): string {
  const labels: Record<string, string> = {
    email: "Email",
    web: "Web",
    extension: "Browser extension",
    x: "X",
    x_bot: "X @CCNoteMe",
    wecom: "WeCom",
    mobile: "Mobile",
    share: "Shared",
    xhs: "小红书",
    reddit: "Reddit",
  } satisfies Record<NoteSource, string>;
  return labels[source] ?? source;
}

/** 1536 → "1.5 KB", 209715200 → "200 MB", 1073741824 → "1 GB" (binary units, as storage limits are). */
export function formatBytes(bytes: number): string {
  const units = ["B", "KB", "MB", "GB", "TB"];
  let value = bytes;
  let i = 0;
  while (value >= 1024 && i < units.length - 1) {
    value /= 1024;
    i++;
  }
  const digits = i === 0 || value >= 100 || Number.isInteger(value) ? 0 : 1;
  return `${value.toFixed(digits).replace(/\.0$/, "")} ${units[i]}`;
}
